export * from './MenuManagementEditButtonArea';
export * from './MenuManagementNewButtonArea';

export const BUTTON_AREA_ID = 'button-area';

import { routes } from '@/router';

export type ListUrl =
  | typeof routes['menuManagementCategories']['path']
  | typeof routes['menuManagementItems']['path']
  | typeof routes['menuManagementMenus']['path']
  | typeof routes['menuManagementOptionGroups']['path']
  | typeof routes['menuManagementExecutions']['path']
  | typeof routes['menuManagementBusinessHours']['path'];
